module.exports = __webpack_public_path__ + "img/ACORN-K.e637b3f3.svg";